import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'money',
    standalone: false
})
export class MoneyPipe implements PipeTransform {

  constructor(
    private decimalPipe: DecimalPipe,
    private translate: TranslateService
  ) {}

  transform(
    amount: number | null | undefined,
    currencyCode: string
  ): string {
    const lang = this.translate.currentLang;

    if (amount == null || !currencyCode) {
      return '';
    }

    const formattedNumber =
      this.decimalPipe.transform(amount, '1.2-2', lang === 'ar' ? 'ar' : 'en');

    if (!formattedNumber) {
      return '';
    }

    // Always isolate as LTR for currency codes + numbers
    return lang === 'ar'
      ? `\u202A${currencyCode} ${formattedNumber}\u202C`
      : `${currencyCode} ${formattedNumber}`;
  }

}
